import html from "../../../../assets/icons/html.svg";
import css from "../../../../assets/icons/css.svg";
import js from "../../../../assets/icons/javascript.svg";
import bootsrap from "../../../../assets/icons/bootstrap.svg";
import react from "../../../../assets/icons/react.svg";
import express from "../../../../assets/icons/express.svg";
import mui from "../../../../assets/icons/material-ui-1.svg";
import mongo from "../../../../assets/icons/mongo.svg";
import node from "../../../../assets/icons/nodejs.svg";
import tailwind from "../../../../assets/icons/tailwind.svg";
import php from "../../../../assets/icons/php.svg";
import java from "../../../../assets/icons/java.svg";
import mysql from "../../../../assets/icons/mysql.svg";
import redux from "../../../../assets/icons/redux.svg";
import figma from "../../../../assets/icons/figma.svg";
import shopify from "../../../../assets/icons/shopify.svg";
import webflow from "../../../../assets/icons/webflow.svg";
import gatsbyjs from "../../../../assets/icons/gatsby.svg";
import nextjs from "../../../../assets/icons/nextjs.svg";
import prismic from "../../../../assets/icons/prismic.svg";
import firebase from "../../../../assets/icons/firebase.svg";
import sp from "../../../../assets/icons/pngegg.png";

const skillList = [
  // Backend Core + Frameworks
  {
    id: 14,
    name: "JAVA",
    img: java,
  },
  {
    id: 12,
    name: "Spring Boot",
    img: sp,
  },
  {
    id: 6,
    name: "NodeJs",
    img: node,
  },
  {
    id: 7,
    name: "expressJs",
    img: express,
  },
  {
    id: 12,
    name: "Php",
    img: php,
  },

  // Databases
  {
    id: 9,
    name: "MongoDB",
    img: mongo,
  },
  {
    id: 13,
    name: "MySQL",
    img: mysql,
  },
  {
    id: 19,
    name: "Firebase",
    img: firebase,
  },

  // Frontend Core
  {
    id: 1,
    name: "Html",
    img: html,
  },
  {
    id: 2,
    name: "CSS",
    img: css,
  },
  {
    id: 11,
    name: "Tailwind",
    img: tailwind,
  },
  {
    id: 4,
    name: "Bootstrap",
    img: bootsrap,
  },
  {
    id: 8,
    name: "Material",
    img: mui,
  },

  // JavaScript Core + Frameworks
  {
    id: 3,
    name: "Javascript",
    img: js,
  },
  {
    id: 5,
    name: "ReactJs",
    img: react,
  },
  {
    id: 10,
    name: "Redux",
    img: redux,
  },
  {
    id: 17,
    name: "NextJs",
    img: nextjs,
  },
  {
    id: 18,
    name: "GatsbyJs",
    img: gatsbyjs,
  },

  // CMS & Design Tools
  {
    id: 19,
    name: "Prismic",
    img: prismic,
  },
  {
    id: 16,
    name: "Webflow",
    img: webflow,
  },
  {
    id: 15,
    name: "Shopify",
    img: shopify,
  },
  {
    id: 15,
    name: "Figma",
    img: figma,
  },
];


export default skillList;
